'use client'

import { DonationProvider } from './context/DonationContext'
import Header from './components/Header'
import Overview from './components/Overview'
import FileUpload from './components/FileUpload'
import FilterSection from './components/FilterSection'
import TabContainer from './components/TabContainer'

export default function DonationManagement() {
  return (
    <DonationProvider>
      <div className="bg-gray-100 p-6">
        <Header />
        <div className="flex gap-6 mb-6">
          <div className="w-1/3">
            <Overview />
          </div>
          <div className="w-2/3">
            <FileUpload />
          </div>
        </div>
        <FilterSection />
        <TabContainer />
      </div>
    </DonationProvider>
  )
}